import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'
import snakeCase from 'voca/snake_case.js'

export const useModelName = (klass, name) => {
  const { t } = useI18nUtils()

  const modelName = name
  const i18nKey = snakeCase(modelName)
  const paramKey = snakeCase(modelName)

  function humanAttributeName(attributeName, options = {}) {
    return t(`attributes.${i18nKey}.${attributeName}`, options)
  }

  function human(options) {
    return t(`models.${i18nKey}`, options)
  }

  Object.defineProperties(klass, {
    modelName: {
     value: {
       name: modelName,
       i18nKey: i18nKey,
       paramKey: paramKey,
       humanAttributeName: humanAttributeName,
       human: human
     },
      writable: false,
      configurable: false,
      enumerable: false
    },
    humanAttributeName: {
      value: (...args) => klass.modelName.humanAttributeName(...args),
      writable: false,
      configurable: false,
      enumerable: false
    }
  })

}